import { Flex, Image, Link, Text } from '@chakra-ui/react';

import { PrivacyOptionsIcon } from '../assets/Images';
import { PRIVACY_CHOICES, PRIVACY_POLICY } from '../constants/urls';
import usePrivacyChoicesInScope from '../hooks/usePrivacyChoicesInScope';

const currentYear = new Date().getFullYear();

const SimpleFooter = () => {
  const showPrivacyChoicesLink = usePrivacyChoicesInScope();

  return (
    <Flex flexDir="column" justifyItems="center" alignItems="center" mt={6}>
      <Text>&#169; {currentYear} Lease End</Text>
      <Link href={PRIVACY_POLICY}>Privacy Policy</Link>
      {showPrivacyChoicesLink && (
        <Link href={PRIVACY_CHOICES} display="inline-flex" alignItems="center" gap={1.5}>
          <Image
            src={PrivacyOptionsIcon}
            alt="California Consumer Privacy Act (CCPA) Opt-Out Icon"
            h="1em"
          />
          Your Privacy Choices
        </Link>
      )}
    </Flex>
  );
};

export default SimpleFooter;
